import { ClientRectObject } from '@floating-ui/react';
import { EditorView } from 'prosemirror-view';

export function getSelectionRect(view: EditorView): ClientRectObject {
  const {
    state: { selection },
  } = view;

  let fromPos;
  let toPos;

  try {
    fromPos = view.coordsAtPos(selection.from);
    toPos = view.coordsAtPos(selection.to);
  } catch {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    };
  }

  const top = Math.min(fromPos.top, toPos.top);
  const left = Math.min(fromPos.left, toPos.left);
  const bottom = Math.max(fromPos.bottom, toPos.bottom);
  const right = Math.max(fromPos.right, toPos.right);

  return {
    x: top,
    y: left,
    top,
    bottom,
    left,
    right,
    width: right - left,
    height: bottom - top,
  };
}
